import { combineEpics } from 'redux-observable';

import widgetStatus from './status/epic';
import widgetConsumer from './consumer/epic';
import widgetSupply from './supply/epic';
import widgetFirmware from './firmware/epic'
import widgetStatusForLast4Hours from './statusForLast4Hours/epic';
import widgetStatusForLast75Mins from './statusForLast75Mins/epic';

export default combineEpics(
  widgetStatus,
  widgetConsumer,
  widgetSupply,
  widgetFirmware,
  widgetStatusForLast4Hours,
  widgetStatusForLast75Mins,
);
